<div #dropdown class="dropdown">
    <button #button class="btn border-0 text-start d-flex justify-content-between align-items-center w-100 p-2 pe-4"
            type="button" data-bs-toggle="dropdown" data-bs-auto-close="outside">
        <div class="d-flex flex-column mw-100 flex-grow-1 me-3">
            <span class="d-inline-block text-truncate">{{ getFacetName() }}</span>
            <div *ngIf="hasValue" class="mt-1 text-secondary d-flex flex-column notranslate">
                <span *ngFor="let value of selectedValueFormatted.split(', ')">{{ value }}</span>
            </div>
        </div>
        <i *ngIf="!hasValue" class="fa fa-fw fa-plus text-secondary"></i>
    </button>
    <div class="btn-close-wrapper rounded-circle position-absolute end-0 me-2 mt-2 top-0"
         [ngClass]="{'d-none': !hasValue}">
        <button type="button" class="btn-close" (click)="removeFilter()" aria-label="Remove filter"></button>
    </div>
    <div class="dropdown-menu min-w-100 overflow-hidden dropdown-menu-flex" [style.max-height.px]="320"
         [style.z-index]="1050">
        <div class="d-flex flex-column w-100">
            <div class="p-3 border-bottom">
                <app-local-filter [appAutoFocus]="true" [autoFocusInOverlay]="true" placeholder="Search"
                                  [data]="facetValues" [term]="term" class="border-0"
                                  (updated)="updateFilteredValues($event)"
                                  (termChanged)="term = $event"></app-local-filter>
            </div>
            <app-scroller (endReached)="loadNextPage()" scrollClass="overflow-auto" [scrollMaxHeightPx]="240" [scrollOffset]="32">
                <ul class="list-group">
                    <ng-container *ngFor="let facetValue of filteredValues; index as i; trackBy: trackByFacetValue">
                        <ng-container *ngIf="facetValue">
                            <li class="list-group-item list-group-item-action border-0 d-flex align-items-stretch p-0">
                                <app-facet-filter-value [term]="term" [facet]="facet" [facetValue]="facetValue"
                                                        [selectedValues]="selectedValues"
                                                        (valueSelected)="facetValueSelected(facetValue, $event)"
                                                        class="w-100 h-100"></app-facet-filter-value>
                            </li>
                        </ng-container>
                    </ng-container>
                </ul>
            </app-scroller>
            <ng-container *ngIf="facetsLoading">
                <div class="w-100 h-100 d-flex align-items-center justify-content-center">
                    <span class="spinner-border spinner-border-sm text-secondary" role="status"></span>
                </div>
            </ng-container>
        </div>
    </div>
</div>
